import React from 'react';
import { Upload, Wand2, FileCheck, ArrowRight } from 'lucide-react';
import { SlideLayout } from '../SlideLayout';
interface SlideProps {
  isActive: boolean;
  currentSlide: number;
  totalSlides: number;
  onNext: () => void;
  onPrev: () => void;
}
export function ProspectDemoSlide(props: SlideProps) {
  return <SlideLayout {...props} theme="dark" title="3 Steps to Done" subtitle="EduAssess streamlines the entire process into a simple, intuitive workflow." data-id="element-160">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12" data-id="element-161">
        {/* Step 1 */}
        <div className="relative group" data-id="element-162">
          <div className="absolute -inset-1 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-2xl blur opacity-25 group-hover:opacity-75 transition duration-1000 group-hover:duration-200" data-id="element-163"></div>
          <div className="relative h-full bg-slate-900 ring-1 ring-slate-800 rounded-xl p-8 flex flex-col items-center text-center" data-id="element-164">
            <div className="w-16 h-16 bg-indigo-500/20 rounded-2xl flex items-center justify-center text-indigo-400 mb-6" data-id="element-165">
              <Upload className="w-8 h-8" data-id="element-166" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-167">
              1. Upload Content
            </h3>
            <p className="text-slate-400 text-sm mb-6" data-id="element-168">
              Drag & drop PDFs, PPTs, audio files, or simply paste a YouTube
              URL.
            </p>
            <div className="mt-auto w-full bg-slate-800 rounded-lg p-3 border border-slate-700" data-id="element-169">
              <div className="flex items-center gap-2 text-xs text-slate-400" data-id="element-170">
                <div className="w-2 h-2 rounded-full bg-red-500" data-id="element-171"></div>
                youtube.com/watch?v=...
              </div>
            </div>
          </div>
          <ArrowRight className="hidden md:block absolute top-1/2 -right-6 text-slate-600 -translate-y-1/2 z-10" data-id="element-172" />
        </div>

        {/* Step 2 */}
        <div className="relative group" data-id="element-173">
          <div className="absolute -inset-1 bg-gradient-to-r from-purple-500 to-pink-500 rounded-2xl blur opacity-25 group-hover:opacity-75 transition duration-1000 group-hover:duration-200" data-id="element-174"></div>
          <div className="relative h-full bg-slate-900 ring-1 ring-slate-800 rounded-xl p-8 flex flex-col items-center text-center" data-id="element-175">
            <div className="w-16 h-16 bg-purple-500/20 rounded-2xl flex items-center justify-center text-purple-400 mb-6" data-id="element-176">
              <Wand2 className="w-8 h-8" data-id="element-177" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-178">
              2. AI Generation
            </h3>
            <p className="text-slate-400 text-sm mb-6" data-id="element-179">
              Our AI analyzes the content and generates high-quality questions
              instantly.
            </p>
            <div className="mt-auto w-full bg-slate-800 rounded-lg p-3 border border-slate-700 space-y-2" data-id="element-180">
              <div className="h-2 bg-slate-700 rounded w-3/4 animate-pulse" data-id="element-181"></div>
              <div className="h-2 bg-slate-700 rounded w-1/2 animate-pulse" data-id="element-182"></div>
              <div className="h-2 bg-slate-700 rounded w-5/6 animate-pulse" data-id="element-183"></div>
            </div>
          </div>
          <ArrowRight className="hidden md:block absolute top-1/2 -right-6 text-slate-600 -translate-y-1/2 z-10" data-id="element-184" />
        </div>

        {/* Step 3 */}
        <div className="relative group" data-id="element-185">
          <div className="absolute -inset-1 bg-gradient-to-r from-pink-500 to-emerald-500 rounded-2xl blur opacity-25 group-hover:opacity-75 transition duration-1000 group-hover:duration-200" data-id="element-186"></div>
          <div className="relative h-full bg-slate-900 ring-1 ring-slate-800 rounded-xl p-8 flex flex-col items-center text-center" data-id="element-187">
            <div className="w-16 h-16 bg-emerald-500/20 rounded-2xl flex items-center justify-center text-emerald-400 mb-6" data-id="element-188">
              <FileCheck className="w-8 h-8" data-id="element-189" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-190">
              3. Review & Export
            </h3>
            <p className="text-slate-400 text-sm mb-6" data-id="element-191">
              Edit if needed, then export a perfectly formatted, branded PDF.
            </p>
            <div className="mt-auto w-full bg-white rounded-lg p-3 border border-slate-200 relative overflow-hidden" data-id="element-192">
              <div className="absolute top-0 right-0 w-4 h-4 bg-indigo-600 rounded-bl-lg" data-id="element-193"></div>
              <div className="h-1.5 bg-slate-200 rounded w-1/3 mb-2" data-id="element-194"></div>
              <div className="h-1 bg-slate-100 rounded w-full mb-1" data-id="element-195"></div>
              <div className="h-1 bg-slate-100 rounded w-full mb-1" data-id="element-196"></div>
            </div>
          </div>
        </div>
      </div>
    </SlideLayout>;
}